import React, { forwardRef } from 'react';
// import { cnMerge } from '../../../utils/utils';

export const Select = forwardRef(
  (
    {
      data,
      // className,
      disabled = false,
      error = false,
      ...props
    },
    ref
  ) => (
    <div
      className={`w-full flex items-center h-14 border ${error ? 'border-red-500' : 'border-customGray-300'} rounded-lg px-5`}
    >
      <select
        ref={ref}
        className={`w-full h-full text-clamp-md ${error && '!border-red-400'}  ${disabled ? 'opacity-50' : 'global-hover'} focus:outline-none cursor-pointer`}
        // ${methods?.watch('roll') === '' ? 'text-customGray-500 font-light' : 'text-customGray-900'}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <option value="" disabled>
          {data.default}
        </option>
        {data?.items?.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  )
);
